import TileV2Graphql from './Tile.v2Graphql'

export default TileV2Graphql
// eslint-disable-next-line import/export
export * from './Tile.v2Graphql'
